import script from "./CreateCampaignPhishing.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateCampaignPhishing.vue?vue&type=script&setup=true&lang=js"

import "./CreateCampaignPhishing.vue?vue&type=style&index=0&id=e194edc4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e194edc4"]])

export default __exports__